<script setup lang="ts">
import { computed } from "vue";
import CanvasButton from "@/components/canvas/CanvasButton.vue";
import type { DraggerConfig } from "@/stores/DraggerMenuState";
import DraggerMenuState from "@/stores/DraggerMenuState";

const props = defineProps<{
  config: DraggerConfig;
  icon?: string;
  phosphorIcon?: string;
  phosphorWeight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
  tooltipText?: string;
  tooltipTitle?: string;
}>();

const isActive = computed(
  () => DraggerMenuState.activeDragger.name === props.config.name,
);
</script>

<template>
  <CanvasButton
    :icon="icon"
    :phosphor-icon="phosphorIcon"
    :phosphor-weight="phosphorWeight"
    :tooltip-text="tooltipText"
    :tooltip-title="tooltipTitle"
    :active="isActive"
  >
    <slot />
  </CanvasButton>
</template>
